var map = {
	"./icon-package-3g-light.svg": 886,
	"./icon-package-4g-light.svg": 887,
	"./icon-package-5g-light.svg": 888,
	"./icon-package-activation-policy-light.svg": 889,
	"./icon-package-arrow-general-light.svg": 890,
	"./icon-package-calling-credit-light.svg": 891,
	"./icon-package-coverage-light.svg": 892,
	"./icon-package-ekyc-micro-light.svg": 893,
	"./icon-package-ekyc-restriction-light.svg": 894,
	"./icon-package-ekyc-validation-light.svg": 895,
	"./icon-package-fup-light.svg": 896,
	"./icon-package-info-general-light.svg": 897,
	"./icon-package-lte-light.svg": 898,
	"./icon-package-network-light.svg": 899,
	"./icon-package-plan-type-light.svg": 900,
	"./icon-package-price-light.svg": 901,
	"./icon-package-supported-arrow-light.svg": 902,
	"./icon-package-topup-option-light.svg": 903,
	"./icon-package-validity-light.svg": 904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2177;